import React from 'react';
import './styles.css';
import FadeInSection from "./FadeInSection";

function ReviewsPage() {
    const stats = [
        { number: '25,000+', label: 'Cases Resolved' },
        { number: '98%', label: 'Client Satisfaction' },
        { number: '15 Million', label: 'Dollars In Recoveries' }
    ];

    const reviews = [
        {
            name: 'Nakia B.',
            text: 'Williams & Williams provided exceptional service. They handled my case quickly and professionally.'
        },
        {
            name: 'Samuel R.',
            text: 'I felt truly supported throughout the process. They made everything easy and stress-free.'
        },
        {
            name: 'Elena J.',
            text: 'The team was responsive, kind, and incredibly effective. I couldn’t have asked for better support.'
        }
    ];

    return (
        <div id="ReviewsPage">
            <FadeInSection>
                <div className={'overfull'} style={{backgroundColor: 'var(--grey)'}}>
                    <h4 style={{textAlign: 'center'}}>Trusted by Clients, Proven by Results</h4>
                    <div id={"statsSection"}>
                        {stats.map((stat, index) => (
                            <div key={index} style={{textAlign: 'center'}}>
                                <h1 style={{
                                    color: 'var(--gold)',
                                    fontSize: '3em',
                                    margin: '10px'
                                }}>{stat.number}</h1>
                                <p style={{margin: 0, fontWeight: 'bold'}}>{stat.label}</p>
                            </div>
                        ))}
                    </div>

                    {/* Reviews Section */}
                    <div id={'reviewCardCont'}>
                        {reviews.map((review, index) => (
                            <div key={index} id={"reviewCards"}>
                                <p style={{fontStyle: 'italic'}}>"{review.text}"</p>
                                <p style={{marginTop: '20px', fontWeight: 'bold', color: 'var(--med)'}}>
                                    – {review.name}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </FadeInSection>
        </div>
    );
}

export default ReviewsPage;
